import Tag from '@sweep-io/sweep-design/dist/components/Tag';

export const NotDeployedTag = () => <Tag label="Not deployed" startIconName="NotePencil" />;
